module.exports = __webpack_public_path__ + "img/pssc.331f4774.svg";